module.exports = __webpack_public_path__ + "img/new11_1_2.24d032f8.png";